import { Geolocation, Position } from "@capacitor/geolocation";
import Graphic from "@arcgis/core/Graphic";

// Global tracking variables
let watchId: any = undefined;
let isZoomTracking: boolean = false;
let isTrackCurrentLocation: boolean = false;

/**
 * Callback function for watch position
 */
export const callBackWatchPosition = (
  position: Position | null, 
  err?: any,
  graphicsLayer?: any,
  MapViewData?: any,
  showToastCallback?: (position: "top" | "middle" | "bottom", color: string, message: string) => void
) => {
  console.log("position", position);
  console.log("err", err);
  
  if (err) {
    if (showToastCallback) {
      showToastCallback("top", "danger", "يرجي تفعيل تحديد الموقع : " + err.message);
    } else {
      alert("يرجي تفعيل تحديد الموقع : " + err.message);
    }
    return;
  }
  
  if (!graphicsLayer || !MapViewData) {
    console.warn("Graphics layer or MapView not provided");
    return;
  }

  graphicsLayer.removeAll();
  let pointDegrees: any = {
    type: "point",
    longitude: position?.coords.longitude,
    latitude: position?.coords.latitude,
  };

  let symbolArrow: any = {
    type: "simple-marker",
    style: "circle",
    size: "25px",
    color: "#0031C4",
    outline: {
      color: "#77A4D2",
      width: "1px",
    },
  };

  let symbolCircle: any = {
    type: "simple-marker",
    style: "circle",
    size: "25px",
    color: "#0031C4",
    outline: {
      color: "#77A4D2",
      width: "1px",
    },
  };

  let pointGraphicForLocationArrow = new Graphic({
    geometry: pointDegrees,
    symbol: symbolArrow,
  });
  let pointGraphicForLocationCircle = new Graphic({
    geometry: pointDegrees,
    symbol: symbolCircle,
  });

  graphicsLayer.add(pointGraphicForLocationCircle);
  graphicsLayer.add(pointGraphicForLocationArrow);

  console.log("isZoomTracking==>", isZoomTracking);
  if (!isZoomTracking) {
    MapViewData.center = pointDegrees;
    MapViewData.goTo(pointGraphicForLocationArrow);
    MapViewData.zoom = 18;
    isTrackCurrentLocation = true;
  }
};

/**
 * Tracks user's location
 */
export const trackingMyLocationFunction = async (
  isNotClear: boolean,
  graphicsLayer?: any,
  MapViewData?: any,
  showToastCallback?: (position: "top" | "middle" | "bottom", color: string, message: string) => void
) => {
  let chcekPremission = await Geolocation.checkPermissions();
  console.log("chcekPremission", chcekPremission);
  
  if (
    chcekPremission.coarseLocation != "denied" &&
    chcekPremission.location != "denied"
  ) {
    if (isNotClear) {
      watchId = await Geolocation.watchPosition(
        { enableHighAccuracy: true, timeout: 1000000 },
        (position) =>{
          if (position) {
          callBackWatchPosition(position, undefined, graphicsLayer, MapViewData, showToastCallback)
          } else {
            if (showToastCallback) {
              showToastCallback("top", "danger", "خطأ في تحديد الموقع الرجاء تفعيل الموقع");
            } else {
              alert("خطأ في تحديد الموقع الرجاء تفعيل الموقع");
            }
          }
        } 
      );
    } else {
      await Geolocation.clearWatch({ id: watchId });
      if (graphicsLayer) {
        graphicsLayer.removeAll();
      }
      isZoomTracking = false;
    }
  } else {
    if (showToastCallback) {
      showToastCallback("top", "danger", "يرجي تفعيل تحديد الموقع");
    } else {
      alert("يرجي تفعيل تحديد الموقع : ");
    }
    return;
  }
};

/**
 * Gets current position
 */
export const getCurrentPosition = async () => {
  try {
    const currentLocation = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 1000000,
    });
    return currentLocation;
  } catch (err: any) {
    console.error("Error getting current position:", err);
    throw err;
  }
};

/**
 * Checks location permissions
 */
export const checkLocationPermissions = async () => {
  return await Geolocation.checkPermissions();
};

/**
 * Clears location watch
 */
export const clearLocationWatch = async () => {
  if (watchId) {
    await Geolocation.clearWatch({ id: watchId });
    watchId = undefined;
  }
};

/**
 * Gets tracking state
 */
export const getTrackingState = () => ({
  isZoomTracking,
  isTrackCurrentLocation
});

/**
 * Sets tracking state
 */
export const setTrackingState = (zoomTracking: boolean, trackCurrentLocation: boolean) => {
  isZoomTracking = zoomTracking;
  isTrackCurrentLocation = trackCurrentLocation;
};

/**
 * Geolocation simulator for testing purposes
 */
export const stubGeolocation = () => {
  let coords = [
    {
      lat: 24.479095,
      lng: 39.60418,
    },
    {
      lat: 24.479837,
      lng: 39.60404,
    },
    {
      lat: 24.480648,
      lng: 39.603826,
    },
    {
      lat: 24.481653,
      lng: 39.6036,
    },
    {
      lat: 24.481214,
      lng: 39.603708,
    },
    {
      lat: 24.480804,
      lng: 39.603794,
    },
    {
      lat: 24.48013,
      lng: 39.603922,
    },
    {
      lat: 24.480296,
      lng: 39.605296,
    },
    {
      lat: 24.477181,
      lng: 39.608997,
    },
    {
      lat: 24.479773,
      lng: 39.614368,
    },
  ];
  
  let currentCoordIndex = 0;
  
  return {
    coords,
    currentCoordIndex,
    getNextCoord: () => {
      const coord = coords[currentCoordIndex];
      currentCoordIndex = (currentCoordIndex + 1) % coords.length;
      return coord;
    },
    reset: () => {
      currentCoordIndex = 0;
    }
  };
};
